import { maxBy } from "lodash";
import { SharingAgencyItem } from "entities/UIModel/SharingAgencyItem";

export function getNextSharingAgencyItem(currentItems: SharingAgencyItem[]): SharingAgencyItem {
  const lastRowId = maxBy(currentItems, "rowId")?.rowId ?? 0;
  return {
    rowId: lastRowId + 1,
    locationFullDisplayName: "",
    selectedLocationFullDisplayName: "",
    companyID: "",
    companyName: "",
    companyLegacyID: "",
    locationUniqueID: "",
    locationLegacyID: "",
    locationDisplayName: "",
    locationStateCode: "",
    locationStateAbbr: "",
    isActive: 1,
  };
}
